import {Button, Modal} from "antd";
import {useState} from "react";
import {DsaScheduleDto} from "../../generated/dashboard-client";
import DSAApi from "../../api/DSAApi";
import "./ConfirmationModal.scss";

export interface DeleteScheduleModalProps {
  schedule: DsaScheduleDto | null;
  isVisible: boolean;
  onClose: (fetch: boolean) => void;
}

export function DeleteScheduleModal({
                                      schedule,
                                      isVisible,
                                      onClose,
                                    }: DeleteScheduleModalProps) {
  const [saving, setSaving] = useState(false);

  function remove() {
    setSaving(true);
    DSAApi.deleteSchedule(schedule?.id!).then(() => {
      setSaving(false);
      onClose(true);
    }).catch(() => {
      setSaving(false);
      onClose(true);
    });
  }

  return (
    <Modal
      className={"confirmation-modal clean"}
      visible={isVisible}
      onCancel={() => onClose(false)}
    >
      <header>
        <h2>Are you sure?</h2>
      </header>

      <p>This schedule will be permanently deleted from your account.</p>

      <footer>
        <Button size={"large"} onClick={() => onClose(false)}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={remove}
          loading={saving}
        >
          Delete
        </Button>
      </footer>
    </Modal>
  );
}
